import { QueryFilterParameter } from "src/app/widgets/filters/models/query-filter-parameter.model";
import { FilterOutput } from "../filter-objects";
import { ForecastChartCaption } from "./fc-overview-models";

export class TopdownAdjustmentData {
    forecastGroups: ForecastElementCaptionData[];
    splitBases: ForecastAjstSplitBaseData[];
    forecastElements: ForecastAjstElementData[];
    unitElements: ForecastAjstElementData[];
}

export class TopdownAdjustmentDataNew {
    forecastGroups: ForecastElementCaptionData[];
    splitBases: ForecastAjstSplitBaseData[];
    forecastElements: DdlData[];
    unitElements: DdlData[];
    defaultElements: DdlData[];
}

export class DdlData {
    title: string;
    value: string;
    extra: string; 
}

export class ForecastAjstGroupsData {
    forecastGroup: string;
}

export class ForecastAjstSplitBaseData {
    elementName: string;
    elementId: number;
    defaultElement: number;
    captionValue: string;
}

export class ForecastElementCaptionData {
    elementName: string;
    elementCaption: string;
    defaultElement: string;
}

export class ForecastAjstElementData {
    elementName: string;
    elementId: number;
}

export class TopdownAdjustmentParam {
    forecastGroupValue: string;
    forecastGroupName: string;
    splitbase: string;
    forecastElemntName: string;
    forecastUnitMeasure: string;
}

export class TopdownAdjustmentList {
    forecastAdjustmentItem: any;
    forecastCaption: ForecastChartCaption[]; 
}

export class TopdownAdjustmentListItem {
    totalForecastSum: number;
    objectRowCount: number;
    period: string;
    elemtSum: number;
    elemtCount: number;
    ajestValue: number;
    removeAjestValue: boolean = false;
}


export class TopdownAddAdjustmentParam {
    unitOfMeasure: string;
    forecastSplit: string;

    forecastGroupName: string;
    forecastGroupValue: string;

    forecastElementId: string;
    topdownAjst: TopdownAddAdjustment[];
}

export class TopdownAddAdjustment {
    period: string;
    ajestValue: number;
    removeAjestValue: boolean;
}

export class TopdownAddAdjustmentSelection {
    forecastElemntNameValue: string;
    forecastUnitMeasureValue: string;
    forecastElemntNameText: string;
    forecastUnitMeasureText: string;
    forecastBaseSplitText: string;
    forecastBaseSplitValue: string;
}


export class TopdownAdjustmentParamNew {
    forecastElemntName: string;
    forecastUnitMeasure: string;
    forecastSplitBase: string;
    UnitOfMeasureName: string;
    forecastItem: Ids[];
}
export class Ids {
    id: string;
}

export class UpdateTopDown {
    forecastElemntName: string;
    forecastSplitBase: string;
    UnitOfMeasureName: string;
    forecastItem: Ids[];
    topdownAjst: TopdownAddAdjustmentNew[];
}

export class TopdownAddAdjustmentNew {
    period: string;
    ajestValue: number;
    removeAjestValue: boolean;
    SpiltBase: number;
}

export class ForecastPeriod {
    period: string;
}

export class ForecastDataExport {
    FromPeriod: string;
    IsAgg: number; 
    ToPeriod: string;
    filters: FilterOutput[] = []; 
}

export class FilesDataExport {
    FromPeriod: string;
    IsAgg: number; 
    ToPeriod: string;
    filters: FilterOutput[] = [];
    type:string;
    title:string;
    filename:string; 
}

export class FilesDataExportQueryFilter {
    FromPeriod: string;
    IsAgg: number; 
    ToPeriod: string;
    filters: QueryFilterParameter[] = [];
    type:string;
    title:string;
    filename:string; 
}
